import Api from './Api';
class SecretariaApi extends Api {

    async recuperarParametros() {
        let result = await this.fetch(this.configuracao.urlParametrosPublico);
        return result.data;
    }

    async recuperarFeaturesFlags() {
        let result = await this.fetch(this.configuracao.urlFeaturesFlags);
        return result.data;
    }

    async recuperarMagistrados() {
        let result = await this.fetch(this.configuracao.urlMagistrados);
        return result.data;
    }

    async recuperarDescricoesCargos() {
        let result = await this.fetch(this.configuracao.urlDescricoesCargos);
        return result.data;
    }

    async recuperarClasses() {
        let result = await this.fetch(this.configuracao.urlClasses);
        return result.data;
    }

    async recuperarProcuradores() {
        let result = await this.fetch(this.configuracao.urlProcuradores);
        return result.data;
    }

    async recuperarSignatariosCertidao() {
        let result = await this.fetch(this.configuracao.urlSignatariosCertidao);
        return result.data;
    }

    async gravarParametro(parametro) {
        let result = await this.fetch(this.configuracao.urlParametros, 'PUT', parametro);
        return result.data;
    }

    async salvarParametro(parametro) {
        let result = await this.fetch(this.configuracao.urlParametros, 'POST', parametro, [
            { parametro: 'Content-type', valor: 'application/json' }
        ]);
        return result.data;
    }

    async excluirParametro(idParametro) {
        let result = await this.fetch(this.configuracao.urlParametros + '/' + idParametro, 'DELETE');
        return result.data;
    }
}

export default SecretariaApi;
